module.exports = __webpack_public_path__ + "img/privilege11.0cafb87f.png";